if (!customElements.get('kimaia-collagen-mix')) {
  customElements.define('kimaia-collagen-mix', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.quantityFirst = this.dataset.quantityFirst === 'true';
      this.labels = JSON.parse(this.querySelector('[data-clm-labels]').textContent);
      this.rows = this.querySelector('[data-clm-rows]');
      this.formatter = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency || 'EUR' });
      this.querySelector('[data-clm-add]').addEventListener('click', () => this.addRow());
      this.querySelectorAll('[data-clm-tier]').forEach(button => button.addEventListener('click', event => { event.preventDefault(); event.stopPropagation(); this.selectTier(Number(button.dataset.clmTier)); }));
      this.rows.addEventListener('input', () => this.update());
      this.rows.addEventListener('change', () => this.update());
      this.rows.addEventListener('click', event => {
        if (event.target.closest('button')) { event.preventDefault(); event.stopPropagation(); }
        const flavor = event.target.closest('[data-clm-flavor]');
        if (flavor) {
          const select = flavor.closest('[data-clm-row-item]').querySelector('select');
          const option = Array.from(select.options).find(item => item.value === flavor.dataset.clmFlavor && !item.disabled);
          if (option) { select.value = option.value; this.update(); }
          return;
        }
        const product = event.target.closest('[data-clm-product]');
        if (product) {
          const row = product.closest('[data-clm-row-item]');
          const selected = row.querySelector('select').selectedOptions[0];
          this.setProduct(row, product.dataset.clmProduct, null, selected?.dataset.flavor);
          this.update();
          return;
        }
        const step = event.target.closest('[data-clm-step]');
        if (step) {
          const input = step.closest('[data-clm-row-item]').querySelector('input');
          const current = Number(input.value);
          const next = Math.max(1, (Number.isSafeInteger(current) ? current : 0) + Number(step.dataset.clmStep));
          if (Number.isSafeInteger(next)) input.value = String(next);
          this.update();
          return;
        }
        const button = event.target.closest('[data-clm-remove]');
        if (!button || this.rows.children.length < 2) return;
        const row = button.closest('[data-clm-row-item]');
        const next = row.nextElementSibling || row.previousElementSibling;
        row.remove();
        next.querySelector('[data-clm-product][aria-pressed="true"]')?.focus();
        this.update();
      });
      const sourceOptions = Array.from(this.querySelector('[data-clm-row]').content.querySelectorAll('option'));
      const defaultOption = sourceOptions.find(option => option.value === this.dataset.defaultVariant);
      const requested = new URLSearchParams(window.location.search);
      const requestedVariant = sourceOptions.find(option => option.value === requested.get('variant') && option.dataset.product === defaultOption?.dataset.product);
      const requestedFlavor = !requestedVariant && sourceOptions.find(option => option.dataset.product === defaultOption?.dataset.product && option.dataset.flavor === requested.get('flavor') && !option.disabled);
      this.addRow(requestedVariant ? requestedVariant.value : requestedFlavor ? requestedFlavor.value : this.dataset.defaultVariant);
      this.ready = true;
      const requestedPots = requested.get('pots');
      if (this.quantityFirst && /^[2-4]$/.test(requestedPots || '')) this.selectTier(Number(requestedPots));
      this.update();
    }
    addRow(variantId) {
      const row = this.querySelector('[data-clm-row]').content.firstElementChild.cloneNode(true);
      row.setAttribute('data-clm-row-item', '');
      const select = row.querySelector('select');
      const options = Array.from(select.options).filter(option => !option.disabled);
      const used = Array.from(this.rows.querySelectorAll('select')).map(item => item.value);
      const chosen = options.find(option => option.value === variantId) || options.find(option => !used.includes(option.value)) || options[0];
      select.value = chosen ? chosen.value : '';
      this.setProduct(row, chosen?.dataset.product, chosen?.value);
      this.rows.append(row);
      if (!variantId) row.querySelector('[data-clm-product][aria-pressed="true"]')?.focus();
      this.update();
    }
    setProduct(row, product, variantId, flavor) {
      const buttons = row.querySelectorAll('[data-clm-product]');
      if (!buttons.length || !product) return;
      const source = Array.from(this.querySelector('[data-clm-row]').content.querySelectorAll('option'));
      const options = source.filter(option => option.dataset.product === product);
      const available = options.filter(option => !option.disabled);
      const chosen = available.find(option => option.value === variantId) || available.find(option => option.dataset.flavor === flavor) || available[0];
      const select = row.querySelector('select');
      select.replaceChildren(...options.map(option => option.cloneNode(true)));
      select.value = chosen ? chosen.value : '';
      buttons.forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.clmProduct === product));
        button.disabled = !source.some(option => option.dataset.product === button.dataset.clmProduct && !option.disabled);
      });
      this.renderFlavors(row);
    }
    renderFlavors(row) {
      const group = row.querySelector('[data-clm-flavors]');
      if (!group) return;
      const select = row.querySelector('select');
      select.hidden = true;
      select.tabIndex = -1;
      select.setAttribute('aria-hidden', 'true');
      group.replaceChildren(...Array.from(select.options).map(option => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.clmFlavor = option.value;
        button.textContent = option.textContent;
        button.disabled = option.disabled;
        button.setAttribute('aria-pressed', String(option.value === select.value));
        return button;
      }));
    }
    selectTier(target) {
      let rows = Array.from(this.rows.children);
      rows.forEach(row => {
        const input = row.querySelector('input');
        if (!input.checkValidity() || !Number.isSafeInteger(Number(input.value))) input.value = '1';
      });
      const currentQuantity = this.getQuantity();
      const rowTarget = !this.quantityFirst && target === 4 && currentQuantity > 4 ? Math.max(4, rows.length) : target;
      if (!this.quantityFirst && target === 4) target = Math.max(4, currentQuantity);
      while (rows.length > target) rows.pop().remove();
      let total = rows.reduce((sum, row) => sum + Number(row.querySelector('input').value), 0);
      for (let i = rows.length - 1; i >= 0 && total > target; i--) {
        const input = rows[i].querySelector('input');
        const reduction = Math.min(Number(input.value) - 1, total - target);
        input.value = String(Number(input.value) - reduction);
        total -= reduction;
      }
      while (total < target) {
        this.addRow(rows[0].querySelector('select').value);
        total++;
      }
      rows = Array.from(this.rows.children);
      while (rows.length < rowTarget) {
        const source = rows.find(row => Number(row.querySelector('input').value) > 1);
        if (!source) break;
        source.querySelector('input').value = String(Number(source.querySelector('input').value) - 1);
        this.addRow(source.querySelector('select').value);
        rows = Array.from(this.rows.children);
      }
      this.update();
    }
    getItems() {
      const items = new Map();
      for (const row of this.rows.children) {
        const select = row.querySelector('select');
        const quantity = row.querySelector('input');
        const selected = select.selectedOptions[0];
        const count = Number(quantity.value);
        if (!selected || selected.disabled || !quantity.checkValidity() || !Number.isSafeInteger(count) || count < 1) return [];
        const total = (items.get(select.value) || 0) + count;
        if (!Number.isSafeInteger(total)) return [];
        items.set(select.value, total);
      }
      return Array.from(items, ([id, quantity]) => ({ id: Number(id), quantity }));
    }
    getSubtotal() {
      return this.getItems().reduce((total, item) => {
        const option = this.querySelector('[data-clm-row]').content.querySelector('option[value="' + item.id + '"]');
        return total + Number(option.dataset.price) * item.quantity;
      }, 0);
    }
    getQuantity() { return this.getItems().reduce((sum, item) => sum + item.quantity, 0); }
    getRate() { const q = this.getQuantity(); return q >= 4 ? 15 : q === 3 ? 10 : q === 2 ? 5 : 0; }
    getTotal() { return Math.round(this.getSubtotal() * (100 - this.getRate()) / 100); }
    formatMoney(amount) { return this.formatter.format(amount / 100); }
    update() {
      this.valid = this.getItems().length > 0;
      const total = this.querySelector('[data-clm-total]');
      total.hidden = !this.quantityFirst && this.valid && this.getQuantity() === 1;
      if (this.quantityFirst) {
        const offer = this.querySelector('[data-clm-offer]');
        const shipping = this.getTotal() >= 5000 ? this.labels.freeShipping : this.labels.mixHint;
        offer.textContent = this.getQuantity() === 1 ? this.labels.pairHint : shipping;
        this.querySelector('[data-clm-add]').hidden = this.getQuantity() < 4;
      }
      if (total.querySelector('[data-clm-price]')) {
        total.querySelector('[data-clm-price]').textContent = this.valid ? this.formatMoney(this.getTotal()) : this.labels.invalid;
        const saving = this.getSubtotal() - this.getTotal();
        const was = total.querySelector('[data-clm-was]');
        was.hidden = !this.valid || !saving;
        was.textContent = this.labels.normal + ' ' + this.formatMoney(this.getSubtotal());
        total.querySelector('[data-clm-savings]').hidden = !this.valid || !saving;
        total.querySelector('[data-clm-savings]').textContent = this.valid ? this.labels.saved.replace('%amount%', this.formatMoney(saving)).replace('%percentage%', this.getRate()) : '';
      } else {
        total.textContent = this.valid ? this.labels.total + ' · ' + this.formatMoney(this.getTotal()) + (this.getRate() ? ' · ' + this.labels.saving.replace('%percentage%', this.getRate()) : '') : this.labels.invalid;
      }
      this.querySelectorAll('[data-clm-tier]').forEach(tier => {
        const active = this.valid && Number(tier.dataset.clmTier) === Math.min(this.getQuantity(), 4);
        tier.classList.toggle('is-active', active);
        tier.setAttribute('aria-pressed', String(active));
      });
      Array.from(this.rows.children).forEach((row, index) => {
        const title = row.querySelector('[data-clm-pot]');
        if (title) title.textContent = this.labels.pot + ' ' + (index + 1);
        row.setAttribute('role', 'group');
        row.setAttribute('aria-label', (this.labels.pot || this.labels.quantity) + ' ' + (index + 1));
        const product = row.querySelector('[data-clm-product][aria-pressed="true"]')?.textContent.trim();
        const flavor = row.querySelector('select').selectedOptions[0]?.textContent || '';
        const choice = [product, flavor].filter(Boolean).join(' · ');
        const select = row.querySelector('select');
        row.querySelectorAll('[data-clm-flavor]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.clmFlavor === select.value)));
        if (this.labels.flavor && !select.hidden) select.setAttribute('aria-label', this.labels.flavor + ' · ' + this.labels.pot + ' ' + (index + 1) + (product ? ' · ' + product : ''));
        row.querySelector('[data-clm-remove]').setAttribute('aria-label', this.labels.remove ? this.labels.remove + ' · ' + (index + 1) : row.querySelector('[data-clm-remove]').getAttribute('aria-label'));
        const input = row.querySelector('input');
        if (this.quantityFirst) {
          row.querySelector('.clm__quantity').hidden = true;
          row.querySelector('[data-clm-remove]').hidden = true;
        }
        const decrease = row.querySelector('[data-clm-step="-1"]');
        if (decrease) decrease.disabled = Number(input.value) <= 1;
        row.querySelectorAll('[data-clm-step]').forEach(button => button.setAttribute('aria-label', (Number(button.dataset.clmStep) > 0 ? this.labels.increase : this.labels.decrease) + ' · ' + choice));
        input.setAttribute('aria-label', this.labels.quantity + ' · ' + choice);
      });
      this.dispatchEvent(new CustomEvent('collagenmixchange', { bubbles: true }));
    }
  });
}


